import React from 'react';
import BlockHeader from '../components/LandingComponents/BlockHeader';
import Block1 from '../components/LandingComponents/Block1'; // Hero
import Block2 from '../components/LandingComponents/Block2'; // Video Button
import Block3 from '../components/LandingComponents/Block3';
import Block4 from '../components/LandingComponents/Block4';
import Block5 from '../components/LandingComponents/Block5';
import Block6 from '../components/LandingComponents/Block6';
import Partners from '../components/LandingComponents/Partners';
import Contact from '../components/LandingComponents/Contact';
import BlockFooter from '../components/LandingComponents/BlockFooter';

const LandingPage = () => (
    <>
        <div style={{position: 'sticky', top: 0, zIndex: 1000}}>
            <BlockHeader/>
        </div>
        <div id="top"><Block1/></div>
        <div id="block2"><Block2 /> </div>
        <div id="block4"><Block4 /> </div>
        <div id="block5"> <Block5 /> </div>
        <div id="block6"> <Block6 /> </div>
        <div id="partners"> <Partners /> </div>
        <div id="contact"> <Contact /> </div>
            <BlockFooter/>
    </>
);

export default LandingPage;